import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BF2042Icon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      transform="translate(0.000000,400.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
    >
      <path d="M3210 3570 c-74 -18 -96 -79 -88 -249 5 -105 19 -139 64 -160 36 -16 107 -25 138 -17 24 6 26 11 26 61 l0 55 -55 0 -55 0 0 99 c0 90 2 100 20 106 32 10 57 -10 221 -172 l156 -154 49 3 c44 3 49 6 52 28 2 18 -7 35 -33 60 -19 18 -35 38 -35 42 0 4 16 8 35 8 l35 0 0 145 0 145 -55 0 -55 0 0 -125 c0 -69 -3 -125 -7 -125 -4 0 -64 56 -133 124 l-125 124 -60 5 c-33 3 -76 2 -95 -3z" />
      <path d="M260 2001 l0 -1568 298 -6 c333 -6 589 5 672 29 142 41 247 152 279 296 30 132 38 855 11 991 -22 112 -72 192 -162 257 l-38 28 40 27 c60 42 116 132 135 219 14 63 16 134 12 527 -3 392 -6 461 -20 503 -48 140 -133 216 -279 251 -51 12 -150 15 -505 15 l-443 0 0 -1569z m773 1168 c68 -31 85 -170 70 -577 -12 -297 -17 -325 -66 -356 -28 -18 -212 -30 -301 -21 l-66 7 0 479 0 479 170 0 c100 0 179 -4 193 -11z m10 -1362 c15 -9 34 -28 43 -42 27 -41 36 -237 27 -565 -8 -284 -9 -297 -31 -327 -30 -43 -91 -54 -268 -51 l-139 3 -3 504 -2 503 173 -4 c144 -3 178 -6 200 -21z" />
      <path d="M1880 2700 l0 -870 -70 0 -70 0 0 -700 0 -700 208 2 207 3 3 698 2 697 375 0 375 0 0 195 0 195 -305 0 -305 0 0 480 0 480 305 0 305 0 0 195 0 195 -515 0 -515 0 0 -870z" />
      <path d="M3127 2663 c-4 -3 -7 -30 -7 -58 l0 -52 188 -140 c249 -185 231 -175 294 -171 l53 3 3 153 3 152 39 0 40 0 0 54 c0 60 -6 66 -69 66 -30 0 -48 -8 -85 -41 l-46 -41 0 41 0 41 -203 0 c-112 0 -207 -3 -210 -7z m413 -194 c0 -61 -3 -78 -12 -73 -24 15 -198 146 -198 150 0 2 47 4 105 4 l105 0 0 -81z" />
      <path d="M3210 1759 c-74 -16 -96 -79 -88 -245 9 -169 25 -177 327 -172 152 2 223 7 238 16 43 24 53 62 53 196 0 208 -1 208 -290 211 -113 0 -221 -2 -240 -6z m415 -204 l0 -90 -192 -3 -193 -2 0 88 c0 49 3 92 7 96 4 3 90 5 192 4 l186 -3 0 -90z" />
      <path d="M3192 853 c-52 -25 -66 -62 -70 -188 -6 -185 24 -230 151 -230 l72 0 3 51 c3 57 -5 64 -75 64 l-33 0 0 100 0 100 32 0 c27 0 53 -21 193 -160 l162 -160 56 0 c54 0 57 1 57 25 0 16 -16 42 -41 70 l-42 45 42 0 41 0 0 145 0 145 -55 0 -55 0 0 -130 c0 -71 -2 -130 -4 -130 -2 0 -50 48 -107 106 -134 135 -176 164 -243 164 -28 0 -66 -8 -84 -17z" />
    </g>
  </svg>
)
const ForwardRef = forwardRef(BF2042Icon)
export { ForwardRef as ReactComponent }
